import { render, staticRenderFns } from "./email-print-configuration.vue?vue&type=template&id=5fd8b9d8"
import script from "./email-print-configuration.vue?vue&type=script&lang=js"
export * from "./email-print-configuration.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports